import { Badge, BadgeVariant } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export type DisputeStatus = string;

export interface DisputeStatusBadgeProps {
  status: DisputeStatus;
  className?: string;
}

// tp_disputes_ch.status is normalized at ingest from each payfac's own dispute
// taxonomy — treat unrecognized values as expected, not a bug.
const getStatusBadgeVariant = (status: DisputeStatus): BadgeVariant => {
  if (['won', 'charge_refunded'].includes(status)) return 'green';
  if (['under_review', 'warning_under_review'].includes(status)) return 'yellow';
  if (['needs_response', 'warning_needs_response'].includes(status)) return 'red';
  if (status === 'lost') return 'red';
  if (status === 'warning_closed') return 'gray';
  return 'gray';
};

const getStatusLabel = (status: DisputeStatus): string =>
  status.replace(/_/g, ' ').replace(/\b\w/g, (l: string) => l.toUpperCase());

export function DisputeStatusBadge({ status, className }: DisputeStatusBadgeProps) {
  return (
    <Badge variant={getStatusBadgeVariant(status)} className={cn('min-w-[72px] justify-center', className)}>
      {getStatusLabel(status)}
    </Badge>
  );
}
